


































































































































































































































































































import { CombinationPreview } from '@/store/models/combinations';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import set from 'lodash/set';
import sortBy from 'lodash/sortBy';
import moment from 'moment';
import VTooltip from 'v-tooltip';
import { Component, Prop } from 'vue-property-decorator';
import { formatter, globalSettings } from '../app.config';
import ClickOutside from '../directives/clickOutside';
import { africaOptions, dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import Calculator from '../helpers/calculator';
import Request from '../models/Request';
import store, { Gender } from '../store';
import { AirportPreview, DestinationPreview, IAirport, ICombination, IDepartureDate, IDestination, IFlight, IPriceCombination, ITour, TourPreview } from '../store/models';
import BaseComponent from './Base';
import NumberInput from './NumberInput.vue';
import Captcha from './Recaptcha';
import TableSelect from './TableSelect.vue';

@Component({
    name: 'EnquireForm',
    components: {
        NumberInput,
        TableSelect,
        Captcha,
    },
    directives: {
        ClickOutside,
    },
})
export default class EnquireForm extends BaseComponent {
    @Prop({ type: Number, default: null }) protected readonly selectedDestinationId: number | null;

    @Prop({ type: Number, default: null }) protected readonly selectedTourId: number | null;

    @Prop({ type: String, default: 'Bottom Enquire Formula' }) protected readonly gtmCategory: string;

    @Prop({ type: String, default: '[]' }) protected readonly marketingSourceOptions: string;

    // @State('destinations', { namespace: 'orm' }) protected readonly storedDestinations: IDestination[];

    // @State('airports', { namespace: 'orm' }) protected readonly storedAirports: IAirport[];

    // @State('combinations', { namespace: 'orm' }) protected readonly storedCombinations: ICombination[];

    // @State('flights', { namespace: 'orm' }) protected readonly storedFlights: IFlight[];

    // @State('tours', { namespace: 'orm' }) protected readonly storedTours: ITour[];

    protected marketingSourceId: string | null = null;

    protected isMarketingSourceIdOther: boolean = false;

    protected marketingSources: Array<{ id: string, name: string }> = [];

    protected autoExpand: boolean = false;

    protected isLoading: boolean = false;

    protected prefix: string = '';

    protected isMounted: boolean = false;

    protected isMobileViewportSize: boolean = false;

    protected hasGender: boolean = globalSettings.isDe || globalSettings.isFr;

    protected hasNewsletter: boolean = !globalSettings.isDe && !(globalSettings.isAsia && globalSettings.isFi);

    protected destinationId: IDestination['id'] | null = null;

    protected tourId: number | null = null;

    protected airportId: number | null = null;

    protected combinationId: number | null = null;

    protected focusedInput: string | null = null;

    protected defaultFocusedInput: string | null = 'destination';

    protected innerDate: number | string | null = null;

    protected name: string = '';

    protected surname: string = '';

    protected phone: string = '';

    protected comment: string = '';

    protected otherDescription: string = '';

    protected adults: number = 2;

    protected children: number = 0;

    protected newsletter: boolean = false;

    protected showErrors: boolean = false;

    protected innerEmail: string = '';

    protected innerGender: number | null = null;

    protected showTourValidation: boolean = false;

    protected showPersonalInfoValidation: boolean = false;

    protected isTooltipEnabled: boolean = false;

    protected stepForwardClicked: boolean = false;

    protected stepSubmitClicked: boolean = false;

    protected captchaTitle: string | null = null;

    protected captchaResponse: any = null;

    protected captchaSiteKey: string | null = null;

    protected STEP_TOUR: number = 0;

    protected STEP_PERSONAL_INFO: number = 1;

    protected STEP_CAPTCHA: number = 2;

    protected GENDER_MALE: number = 1;

    protected GENDER_FEMALE: number = 2;

    protected NO_COMBINATION: CombinationPreview = {
        id: 0,
        sid: null,
        name: this.t('No combination', 'enquire'),
        forChildren: true,
    };

    protected stepId: number = this.STEP_TOUR;

    protected get destinations(): DestinationPreview[] {
        const order: Array<IDestination['id']> = get(africaOptions, 'ordering.destinations') || [];
        const destinations: DestinationPreview[] = store.getters['orm/destinations'].map(({ id, sid, name }) => ({ id, sid, name }));  // Transform

        return sortBy(destinations, ({ id }) => order.includes(id) ? order.indexOf(id) : 999);
    }

    protected errors: { [key: string]: string } = {
        destination: '',
        tour: '',
        date: '',
        airport: '',
        combination: '',
        gender: '',
        name: '',
        surname: '',
        email: '',
        marketingSource: '',
        otherDescription: '',
    };

    protected get hasCombinations(): boolean {
        if (this.combinations.length) {
            return true;
        }
        const flight = this.flight;
        if (!flight) {
            return false;
        }
        return flight.prices.some(({ combinations }) => !!combinations.length);
    }

    protected get email(): string {
        return this.innerEmail;
    }

    protected set email(email: string) {
        this.innerEmail = typeof email === 'string' ? email.replace('â€“', '-') : '';
    }

    protected get airport(): AirportPreview | null {
        return this.airports.find((a) => a.id === this.airportId) || null;
    }

    protected set airport(a: AirportPreview | null) {
        this.airportId = a !== null ? a.id : null;
        this.onSelectChanged('airport');
    }

    protected get combination(): CombinationPreview {
        return this.combinations.find((c) => c.id === this.combinationId) || this.NO_COMBINATION;
    }

    protected set combination(c: CombinationPreview) {
        this.combinationId = c.id;

        if (!this.isChildrenAllowed) {
            this.children = 0;
        }

        this.onSelectChanged('combination');
    }

    protected get gender(): Gender | null {
        return this.genders.find((g) => g.value === this.innerGender) || null;
    }

    protected set gender(g: Gender | null) {
        this.innerGender = g ? g.value : null;
        this.onSelectChanged('gender');
    }

    protected get destination(): DestinationPreview | null {
        return this.destinations.find((d) => d.id === this.destinationId) || null;
    }

    protected set destination(d: DestinationPreview | null) {
        this.destinationId = d ? d.id : null;
        this.tourId = null;

        if (this.destinationId) {
            store.dispatch('orm/loadTours', { destinationId: this.destinationId });
        }

        this.onSelectChanged('destination');
    }

    protected get marketingSource(): { name: string, id: string } | null {
        return this.marketingSources.find((i) => i.id === this.marketingSourceId) || null;
    }

    protected set marketingSource(i: { name: string, id: string } | null) {
        this.marketingSourceId = i ? i.id : null;
        this.isMarketingSourceIdOther = (this.marketingSourceId !== null && this.marketingSourceId.toLowerCase() === 'other');
        // this.closeAllExceptInput();
        this.onSelectChanged('marketingSourceId');
    }

    protected get tour(): TourPreview | null {
        return this.tours.find(({ id }) => id === this.tourId) || null;
    }

    protected set tour(t: TourPreview | null) {
        this.tourId = t ? t.id : null;

        this.airportId = null;
        this.innerDate = null;

        if (!this.isChildrenAllowed) {
            this.children = 0;
        }

        if (t && t.sid) {
            store.dispatch('orm/loadFlights', { tourId: t.sid });
            store.dispatch('orm/loadCombinations', { tourId: t.id });
        }

        this.onSelectChanged('tour');
    }

    protected get flight(): IFlight | null {
        const sid = this.tour ? this.tour.sid : null;

        return store.getters['orm/flights'].find((r) => r.tourSid === sid) || null;
    }

    protected get date(): IDepartureDate | null {
        return this.dates.find((d) => d.id === this.innerDate) || null;
    }

    protected set date(d: IDepartureDate | null) {
        this.innerDate = d !== null ? d.id : null;
        this.combinationId = null;
        this.airportId = null;

        if (this.flight && this.flight.airportSids) {
            store.dispatch('orm/loadAirports', { airportSids: this.flight.airportSids });
        }

        this.onSelectChanged('date');
    }

    protected get inputs(): string[] {
        const inputs: string[] = [];

        if (this.selectedDestinationId === null) {
            inputs.push('destination');
        }

        if (this.selectedTourId === null) {
            inputs.push('tour');
        }

        inputs.push('marketingSource');
        inputs.push('date', 'airport');

        if (this.combinations.length > 0) {
            inputs.push('combination');
        }
        if (this.hasGender) {
            inputs.push('gender');
        }

        return inputs;
    }

    protected get nextInput(): string | null {
        if (this.focusedInput === null) {
            return null;
        }
        const idx = this.inputs.indexOf(this.focusedInput);
        if (idx === -1 || idx === this.inputs.length - 1) {
            return null;
        }
        return this.inputs[idx + 1];
    }

    protected get isLastInput(): boolean {
        return this.nextInput === null;
    }

    protected get nextComponent(): TableSelect | null {
        if (this.nextInput === null) {
            return null;
        }
        const component = this.$refs[this.nextInput];

        return component instanceof TableSelect ? component : null;
    }

    protected get genders(): Gender[] {
        return [
            {
                value: 1,
                display: this.t('Mr'),
            },
            {
                value: 2,
                display: this.t('Ms'),
            },
        ];
    }

    protected get tours(): TourPreview[] {
        const order: Array<ITour['id']> = get(africaOptions, `ordering.tours.${ this.destinationId }`) || [];
        const tours = store.getters['orm/tours']
            .filter(({ destinationIds }) => {
                if (Array.isArray(destinationIds) && destinationIds.length > 0) {
                    return destinationIds.includes(this.destinationId as IDestination['id']);
                }
                return false;
            })
            .map(({ id, sid, name, fullName, forChildren }) => ({ id, sid, name: fullName ? fullName : name, forChildren })); // Transform

        return sortBy(tours, ({ id }) => order.includes(id) ? order.indexOf(id) : 999);
    }

    protected get dates(): IDepartureDate[] {
        const flight = this.flight;
        if (!flight) {
            return [];
        }
        const dates: IDepartureDate[] = [];
        const isSecret = flight.secret || location.search === '?secret';
        flight.prices.forEach((price, id) => {
            const d = moment(price.date, 'YYYY-MM-DD', true);
            if (!d.isValid()) {
                return;
            }
            let display = d.format('DD-MMM-YYYY');

            if (Calculator.isSoldOut(price.adultPrice) || Calculator.isOnRequest(price.adultPrice)) {
                display += ' - ' + (Calculator.isSoldOut(price.adultPrice) ? this.t('Soldout') : this.t('On request'));
            } else {
                display += !isSecret ? ' - ' + formatter.asCurrency(price.adultPrice) : '';
            }

            dates.push({
                id,
                direct: false,
                value: price.date,
                display,
                disabled: Calculator.isSoldOut(price.adultPrice),
            });
            if (!isSecret && price.adultPriceWithDirectFlight) {
                display = d.format('DD-MMM-YYYY');
                display += ' - ' + formatter.asCurrency(price.adultPriceWithDirectFlight) + ' (' + this.t('Direct flight') + ')';
                dates.push({
                    id: `${ id }df`,
                    direct: true,
                    value: price.date,
                    display,
                    disabled: Calculator.isSoldOut(price.adultPriceWithDirectFlight),
                });
            }
        });

        return dates;
    }

    protected get airports(): AirportPreview[] {
        const flight = this.flight;
        const date = this.date;
        if (!flight || !date) {
            return [];
        }
        const order: Array<IAirport['id']> = get(africaOptions, 'ordering.airports') || [];
        const departure = !date.disabled ? moment(date.value) : moment();
        // For direct customer must pick basic airport
        const filtered = store.getters['orm/airports'].filter(({ basic, sid }) => basic || (!date.direct && flight.airportSids.includes(sid || 0)));

        const result: AirportPreview[] = filtered.map(({ id, sid, name, prices }) => {
            const period = prices.find((p) => p.flightId === flight.id && departure.isBetween(p.dayStart, p.dayEnd, 'date', '[]'));

            return { id, sid, name: period ? `${ name } ${ formatter.asRatio(period.price) }` : name };
        });

        return sortBy(result, ({ id }) => order.includes(id) ? order.indexOf(id) : 999);
    }

    protected get combinations(): CombinationPreview[] {
        const flight = this.flight;
        const date = this.date;
        if (!flight || !date) {
            return [];
        }
        const order: Array<ICombination['id']> = get(africaOptions, `ordering.combinations.${ this.tourId }`) || [];
        const result: Array<CombinationPreview & { price?: number }> = [];
        const combinations: IPriceCombination[] = get(flight.prices.find((p) => p.date === date.value), 'combinations') || [];
        sortBy(store.getters['orm/combinations'], ({ id }) => order.includes(id) ? order.indexOf(id) : 999).forEach(({ id, sid, name, forChildren }) => {
            const combination = combinations.find(({ combinationSid }) => combinationSid === sid);
            if (!combination) {
                return;
            }
            const { adultPrice: price } = combination;

            result.push({ id, sid, name: price ? `${ name } ${ formatter.asRatio(price) }` : name, price: Number(price), forChildren });
        });

        return result.length ? [this.NO_COMBINATION, ...sortBy(result, 'price')] : [];
    }

    protected get request(): Request {
        const request = new Request();

        const data: { [key: string]: any } = {
            destination: this.destinationId,
            tour: this.tourId,
            airport: this.airportId,
            // date: this.innerDate,
            date: this.date ? this.date.value : null,
            combination: this.combinationId === 0 ? null : this.combinationId,
            gender: this.hasGender ? this.innerGender : 0,
            name: this.name,
            surname: this.surname,
            email: this.email,
            phone: this.phone,
            comment: this.comment,
            newsletter: this.newsletter,
            adults: this.adults,
            children: this.children,
            directFlight: this.date ? this.date.direct : null,
            marketingSource: this.marketingSources.length === 0 ? 'off' : this.marketingSourceId, // set the of to disable the check when there are no values for the field
            marketingSourceId: this.marketingSourceId,
            otherDescription: this.otherDescription,
        };

        Object.keys(data).forEach((name) => {
            if (typeof data[name] === 'string') {
                set(request, name, data[name].trim());
            }
            if (Number.isInteger(data[name]) || /^\d+$/.test(String(data[name]))) {
                set(request, name, parseInt(data[name], 10));
            }
            if (typeof data[name] === 'boolean') {
                set(request, name, data[name] === true);
            }

        });

        return request;
    }

    protected get isChildrenAllowed(): boolean {
        const flightForChildren = this.flight ? this.flight.forChildren : true;
        const tourForChildren = this.tour ? this.tour.forChildren : true;

        if (!(flightForChildren && tourForChildren)) {
            return false;
        }

        if (this.combination.id !== 0) { // No combination has ID = 0
            return this.combination.forChildren;
        }

        return true;
    }

    public isNextStepLocked(): boolean {
        return false;
        /*return this.destinationId === null ||
            this.tourId === null ||
            this.date === null ||
            this.airportId === null ||
            this.adults < 1;*/
    }

    public isFocusedInputValueSet(): boolean {
        switch (this.focusedInput) {
            case 'destination':
                return this.destinationId !== null;
            case 'tour':
                return this.tourId !== null;
            case 'departure':
                return this.date !== null;
            case 'airport':
                return this.airportId !== null;
            case 'combination':
                return this.combinationId !== null;
            case 'gender':
                return this.innerGender !== null;
            default:
                return false;
        }
    }

    public isDateDisabled(option: any): boolean {
        return option.disabled === true;
    }

    public tooltipOps(field: string): any {

        const isTourValidation = ['destination', 'tour', 'date', 'airport', 'adults', 'children'].indexOf(field) > -1;

        let isTypeCorrepondToPage = false;
        if (this.stepForwardClicked && isTourValidation && this.stepId !== this.STEP_PERSONAL_INFO) {
            isTypeCorrepondToPage = true;
        } else if (this.stepSubmitClicked && !isTourValidation && this.stepId === this.STEP_PERSONAL_INFO) {
            isTypeCorrepondToPage = true;
        }

        return {
            content: this.errors[field],
            container: this.$el,
            classes: 'c-tooltip--error',
            show: !this.isMobileViewportSize && isTypeCorrepondToPage && this.errors[field] !== '',
            trigger: 'manual',
            autoHide: false,
            hideOnTargetClick: false,
            offset: 5,
        };
    }

    public onCaptchaResponse(captchaResponse: any): void {
        this.captchaResponse = captchaResponse;
        this.submit();
    }

    /**
     * This method will be fired when the form is submitted.
     */
    public submit(): void {

        this.stepSubmitClicked = true;
        const vm = this;
        // Close all selects
        this.closeAllExceptInput();

        this.validateRequest().then((errors) => {
            if (errors === false) {
                this.isLoading = true;
                this.request.save(this.captchaResponse).then(() => {
                    dataLayer.push({
                        eventAction: 'desktop',
                        eventLabel: capitalize(get(africaOptions, 'page.controller', '')) + ' page',
                        eventCategory: vm.gtmCategory,
                        event: 'enquireForm:submit',
                    });
                    this.isLoading = false;
                    this.$emit('submit', this.request);
                }, (reason: { key: string, title: string }) => {
                    if (typeof reason.key !== 'undefined') {
                        this.captchaSiteKey = reason.key;
                        this.captchaTitle = reason.title;
                        this.stepId = this.STEP_CAPTCHA;
                        this.$emit('showCaptcha');
                    }
                    this.isLoading = false;
                });
            } else {
                this.showErrors = true;
                this.showPersonalInfoValidation = true;
                this.$emit('submitError', this.errors);
            }
        });
    }

    /**
     * Close all selects when user clicks outside of the form.
     */
    public onClickOutsideForm(): void {
        this.closeAllExceptInput();
    }

    public closeAllExceptInput(name?: string): void {
        this.inputs.forEach((ref) => {
            if (ref === name) {
                return;
            }
            const component = this.$refs[ref];
            if (component instanceof TableSelect) {
                component.expand(false);
            }
        });
    }

    public maybeFocusNextInput(): void {
        if (!this.autoExpand || !this.nextComponent) {
            this.closeAllExceptInput();
            return;
        }

        const noValues = [null, 0, undefined];
        const nextValue = this.nextComponent.getValue();
        const nextId = get(nextValue, 'id', 0);

        if (noValues.indexOf(nextValue) !== -1 || noValues.indexOf(nextId) !== -1) {
            this.nextComponent.expand();
            return;
        }
    }

    public onSelectExpanded(state: boolean, name: string): void {
        if (state === true) {
            this.closeAllExceptInput(name);
            this.focusedInput = name;
            dataLayer.push({
                eventAction: 'Select Expanded',
                eventLabel: name,
                eventCategory: this.gtmCategory,
                event: 'enquireForm:selectExpanded',
            });
        }
    }

    public onSelectChanged(name): void {
        this.$nextTick(this.maybeFocusNextInput);
        dataLayer.push({
            eventAction: 'Select Changed',
            eventLabel: name,
            eventCategory: this.gtmCategory,
            event: 'enquireForm:selectChanged',
        });
    }

    public onWindowResize(): void {
        this.isMobileViewportSize = window.innerWidth < 768;

        if (this.isTooltipEnabled && this.isMobileViewportSize) {
            this.isTooltipEnabled = false;
            VTooltip.enabled = false;
        }

        if (!this.isTooltipEnabled && !this.isMobileViewportSize) {
            this.isTooltipEnabled = true;
            VTooltip.enabled = true;
        }
    }

    public validateRequest(): Promise<any> {
        const errors = {
            destination: '',
            tour: '',
            date: '',
            airport: '',
            combination: '',
            gender: '',
            name: '',
            surname: '',
            email: '',
            marketingSource: '',
            otherDescription: '',
        };

        return new Promise((resolve) => {
            this.request.validate().then(() => {
                this.errors = errors;
                resolve(false);
            }, () => {
                this.request.collectErrors().forEach((collection) => {
                    collection.path.forEach((elName) => {
                        errors[elName] = collection.errors.map((error) => error.message).join('<br>');
                    });
                });

                this.errors = errors;
                resolve(this.errors);
            });
        });
    }

    public created(): void {
        this.prefix = this.uniqId;

        if (this.marketingSourceOptions) {
            try {
                const marketingSources = atob(this.marketingSourceOptions);
                this.marketingSources = JSON.parse(marketingSources);
            } catch (e) {
                //
            }
        }

        // init
        this.destinationId = this.selectedDestinationId || null;
        if (this.destinationId) {
            this.defaultFocusedInput = 'tour';
        }

        store.dispatch('orm/loadDestinations')
            .then(() => {
                if (this.destinationId || this.selectedTourId) {
                    // Если у нас страница тура, то нужно загружать список туров не по дестинейшену,
                    // а по ид тура.
                    store.dispatch('orm/loadTours', { tourId: this.selectedTourId, destinationId: this.destinationId })
                        .then(() => {
                            if (this.selectedTourId) {
                                const tour = store.getters['orm/tours'].find(({ id }) => id === this.selectedTourId);
                                // console.debug('tour', tour);
                                if (!tour) { return; }

                                // The order of assignments is important here
                                this.destinationId = get(tour.destinationIds, '0') || null;
                                this.tourId = tour.id;
                                this.defaultFocusedInput = 'date';

                                store.dispatch('orm/loadFlights', { tourId: tour.sid });
                                store.dispatch('orm/loadCombinations', { tourId: tour.id });
                            }
                        });
                }
            });

        // console.debug('this.destinationId', this.destinationId);
    }

    protected onExternalDateSet(date: number | null): void {
        if (date === null) {
            this.date = null;
            return;
        }
        const value = moment(date).format('YYYY-MM-DD');
        this.date = this.dates.find((d) => d.value === value) || null;
        this.focusedInput = 'date';
        this.maybeFocusNextInput();
    }

    protected onToggle(toggled: boolean): void {
        if (!toggled || !this.autoExpand) {
            return;
        }
        const input = this.inputs.find((i) => {
            const c = this.$refs[i];
            return c instanceof TableSelect && !c.getValue();
        });
        const component = this.$refs[input || ''];
        if (component instanceof TableSelect) {
            component.expand();
        }
    }

    protected stepBack(): void {
        this.stepId = this.STEP_TOUR;
        this.$emit('stepChanged', this.STEP_TOUR);
        dataLayer.push({
            eventAction: 'Step Back',
            eventCategory: this.gtmCategory,
            event: 'enquireForm:stepBack',
        });
    }

    protected stepForward(btn: string): void {
        if (btn === 'proceed') {
            this.stepForwardClicked = true;
        }
        if (this.errors.destination !== '' || this.errors.tour !== '' || this.errors.date !== ''
            || this.errors.airport !== '') {
            this.showTourValidation = true;
        } else {
            this.stepId = this.STEP_PERSONAL_INFO;
            this.$emit('stepChanged', this.STEP_PERSONAL_INFO);
            dataLayer.push({
                eventAction: 'Step Forward',
                eventCategory: this.gtmCategory,
                event: 'enquireForm:stepForward',
            });
        }
    }

    protected mounted(): void {
        this.isMounted = true; // used only for transition animation on load

        this.$watch('request', this.validateRequest, { deep: true });

        EventBus.$on('enquireForm:dateSet', this.onExternalDateSet);
        EventBus.$on('enquireForm:toggle', this.onToggle);

        VTooltip.enabled = false;
        this.onWindowResize();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
    }

    protected beforeDestroy(): void {
        EventBus.$off('enquireForm:dateSet', this.onExternalDateSet);
        EventBus.$off('enquireForm:toggle', this.onToggle);
        window.removeEventListener('resize', this.onWindowResize);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EnquireForm.vue